export const EU_STATUSB_CARDS: {
    [key: string]: any;
} = {
    de: [
        {
            title: 'EcoFlow DELTA 3 Plus',
            subtitle: '1 024 Wh Kapazität',
            desc: '1 800 W Ausgangsleistung und  1000 W PV-Eingangsleistung',
            launch: 'Geplanter Verkaufsstart ab 10. Dezember',
        },
        {
            title: 'EcoFlow DELTA 3',
            subtitle: '1 024 Wh Kapazität',
            desc: '1 800 W Ausgangsleistung und 500 W PV-Eingangsleistung',
            launch: 'Geplanter Verkaufsstart ab 10. Dezember',
        },
    ],
    es: [
        {
            title: 'EcoFlow DELTA 3 Plus',
            subtitle: 'Capacidad de 1024 Wh',
            desc: 'Salida de 1800 W y entrada fotovoltaica de 1000 W',
            launch: 'Lanzamiento previsto el 19 de diciembre',
        },
        {
            title: 'EcoFlow DELTA 3',
            subtitle: 'Capacidad de 1024 Wh',
            desc: 'Salida de 1800 W y entrada fotovoltaica de 500 W',
            launch: 'Lanzamiento previsto el 19 de diciembre',
        },
    ],

    eu: [
        {
            title: 'EcoFlow DELTA 3 Plus',
            subtitle: '1024Wh Capacity',
            desc: '1800W Output & 1000W PV Input',
            launch: 'Scheduled for release on 19 Dec',
        },
        {
            title: 'EcoFlow DELTA 3',
            subtitle: '1024Wh Capacity',
            desc: '1800W Output & 500W PV Input',
            launch: 'Scheduled for release on 19 Dec',
        },
    ],

    ph: [
        {
            title: 'DELTA 3',
            subtitle: '1024Wh Capacity',
            desc: '1800W Output & 500W PV Input',
        },
        {
            title: 'DELTA 3 Plus',
            subtitle: '1024Wh Capacity',
            desc: '1800W Output & 1000W PV Input',
        },
    ],

    fr: [
        {
            title: 'EcoFlow DELTA 3 Plus',
            subtitle: '1 024 Wh de capacité',
            desc: "1 800 W de puissance de sortie \n 1 000 W de puissance d'entrée solaire",
            launch: 'Disponible dès le 19/12',
        },
        {
            title: 'EcoFlow DELTA 3',
            subtitle: '1 024 Wh de capacité',
            desc: "1 800 W de puissance de sortie \n 500 W de puissance d'entrée solaire",
            launch: 'Disponible dès le 19/12',
        },
    ],

    it: [
        {
            title: 'EcoFlow DELTA 3 Plus',
            subtitle: 'Capacità di 1.024 Wh',
            desc: 'Uscita da 1.800 W e ingresso FV da 1.000 W',
            launch: 'Lancio in programma il 19 dicembre',
        },
        {
            title: 'EcoFlow DELTA 3',
            subtitle: 'Capacità di 1.024 Wh',
            desc: 'Uscita da 1.800 W e ingresso FV da 500 W',
            launch: 'Lancio in programma il 19 dicembre',
        },
    ],

    nl: [
        {
            title: 'EcoFlow DELTA 3 Plus',
            subtitle: '1024 Wh capaciteit',
            desc: '1800W uitgangsvermogen en 1000W PV-ingangsvermogen',
            launch: 'De release staat gepland voor 19 december',
        },
        {
            title: 'EcoFlow DELTA 3',
            subtitle: '1024 Wh capaciteit',
            desc: '1800W uitgangsvermogen en 500W PV-ingangsvermogen',
            launch: 'De release staat gepland voor 19 december',
        },
    ],

    uk: [
        {
            title: 'EcoFlow DELTA 3 Plus',
            subtitle: '1024Wh Capacity',
            desc: '1800W Output & 1000W PV Input',
            launch: 'Scheduled for release on 19 Dec',
        },
        {
            title: 'EcoFlow DELTA 3',
            subtitle: '1024Wh Capacity',
            desc: '1800W Output & 500W PV Input',
            launch: 'Scheduled for release on 19 Dec',
        },
    ],
};
